import { fetchApi } from 'src/_helpers/client/fetchApi'
import { buildUrl } from 'src/_helpers/buildUrl'

const PATH = '/api/open/meilisearch/search'

export async function searchMeilisearch(params = {}) {
  const url = buildUrl(PATH, params)
  return await fetchApi(url, 'GET', { accept: 'application/json' }, { cache: 'no-store' })
}
